<script lang="ts">
  import { createEventDispatcher } from 'svelte'

  export let url: string
  export let placeholder: string

  const dispatch = createEventDispatcher<{
    'create': () => void
  }>()

  const create = () => {    
    dispatch('create')
  }
</script>

<div class="file-form">
  <div class="title">
    <input 
      {placeholder}
      type="text"
      bind:value={url}
    />

    {#if url}
      <i class="icon-check" on:click={create} />
    {/if}
  </div>
</div>

<style lang="scss">
  .file-form {
    min-width: 230px;
    box-sizing: border-box;
    color: #2B50ED;
    font-size: 10px;
    font-weight: 600;
    line-height: 18px;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0px 9px 27px 0px #00000012;
    cursor: pointer;

    i {
      color: #12C97A;
      background: #D0F1E1;
      border-radius: 50px;
      font-size: 12px !important;
      margin: 0 !important;
      display: flex;
      padding: 6px;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: 8px;
    }

    input {
      border: none;
      background-color: #E0E8F6;
      outline: none;
      color: #22252C;
      font-size: 10px;
      line-height: 18px;
      width: 100%;

      &::placeholder {
        color: #2B50ED;
        font-size: 10px;
        line-height: 18px;
        letter-spacing: 0em;
      }
    }

    .title {
      display: flex;
      align-items: center;
      background-color: #E0E8F6;
      border-radius: 4px;
      padding: 11px 16px;
      position: relative;

      i {
        font-size: 14px;
        margin-left: 12px;

        &:before {
          margin: 0;
        }
      }
    }
  }
</style>